// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27_EM","content":"styles_content__3fJqb"};